module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    attrs: {
      "id": "cwrap"
    }
  }, [_c('Bgcanvas'), _vm._v(" "), _c('acHead'), _vm._v(" "), _c('div', {
    staticClass: "content  el-col el-col-24"
  }, [_c('div', {
    staticClass: "con-wrap el-col"
  }, [(_vm.isRouterAlive) ? _c('div', {
    staticClass: "content-box"
  }, [_c('acContent'), _vm._v(" "), _c('acFoot')], 1) : _vm._e()])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "请扫描关注公众号",
      "visible": _vm.showQrCode,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showQrCode = $event
      }
    }
  }, [_c('span', [_vm._v("绑定微信后，可实时收到备案事项提醒消息，以及系统更新公告等内容推送。\n                请尽快用微信扫码绑定您的账号。")]), _vm._v(" "), _c('img', {
    staticClass: "qr-img",
    attrs: {
      "src": _vm.qrCodeUrl
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-351174cd","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/component/Wrap.vue
// module id = 1206
// module chunks = 2